import { useToast } from '@cad-arc';
import { useMemo } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useCurrentUser } from '../current-user/current-user';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { createStreamListener, useStream } from '../socket/use-stream';

export function DexInquiryFailureListener() {
    const { isWeb } = useApplicationType();
    const toast = useToast();
    const currentUser = useCurrentUser();
    const streamListener = useMemo(() => {
        const streamListener = createStreamListener({
            streamNames: ['dexInquiryFailedNotifications'],
            onMessage(message) {
                if (
                    (isWeb || electronBridge?.args['--workspace-window-type'] === 'EVENT_V2') &&
                    message.payload.userId === currentUser.userId
                ) {
                    toast({
                        status: 'default',
                        description: message.payload.message,
                    });
                }
            },
        });
        return streamListener;
    }, [toast, currentUser, isWeb]);
    useStream(streamListener);
    return null;
}
